import produce from 'immer'
import { combineReducers } from 'redux'
import { AWARD_RESULT_FETCH_SUCCESS } from '../action/constants'

const initialState = {
  byIds: {},
}

const idsReducer = produce((draft, action) => {
  if (action.type === AWARD_RESULT_FETCH_SUCCESS) {
    draft[action.payload.award._id] = action.payload
  }
}, initialState.byIds)

const awardResultReducer = combineReducers({
  byIds: idsReducer,
})

export default awardResultReducer
